export default {
  title: "مدیریت تگها",
  addNew: "افزودن تگ جدید",
  edit: "ویرایش تگ {{title}}",
  category: "دسته‌بندی",
  subcategory: "زیردسته‌بندی",
  editLabel: "ویرایش تگ",
};
